import React from 'react';
import {render} from 'react-dom';

import WidgetEuro from '../modules/euro-2020';
import {GROUPS} from '../modules/euro-2020/constants/groups';
import {PLAYOFF_STAGES} from '../modules/euro-2020/constants/play-off-stages';
import '../website-ui/i18n/config';

const isMobile = window.Site.targeting.platform === 'smartphone';

const mockData = {
  groups: GROUPS,
  stages: PLAYOFF_STAGES
};

render(
  <WidgetEuro
    isMobile={isMobile}
    mockData={mockData}
    theme="Euro"
  />,
  document.getElementById('js-widget-euro')
);
